import Counter from 'src/components/Counter';
import useMatchCount from 'src/hooks/useMatchCount/socket';
const START = 0;

// 최근 10분 매치 수
const RecentMatchCounter: React.FC = props => {
  const end = useMatchCount();
  return <Counter start={START} end={end || START} {...props} data-sentry-element="Counter" data-sentry-component="RecentMatchCounter" data-sentry-source-file="index.tsx" />;
};
export default RecentMatchCounter;